<template>
  <div>
    <ed-form :model="formData">
      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        label="Empresa"
        v-model="formData.id_emp"
        :items="lstEmpresa"
        :loading="loadingEmpresa"
        @search="getEmpresa"
        clearable
        remote
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        label="Número do Recibo"
        v-model="formData.busca"
        :disabled="!formData.id_emp ? true : false"
      />

      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-5">
        <ed-button
          type="success"
          label="Consultar Informações no eSocial"
          icon="fa fa-search"
          :loading="loading"
          :disabled="!formData.id_emp || !formData.busca ? true : false"
          @click="consultar"
        />
      </div>
    </ed-form>

    <div class="consulta-esocial-erro" v-if="erro">
      <i class="fa fa-exclamation-triangle"></i>
      <span>{{ erro }}</span>
    </div>

    <div class="col-12 mt-5" v-if="formData.strXml">
      <div class="consulta-esocial-contexto">
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Recibo</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.busca }}</span>
        </div>
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Empresa</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.empresa }}</span>
        </div>
        <div class="consulta-esocial-contexto__item">
          <span class="consulta-esocial-contexto__label">Consultado em</span>
          <span class="consulta-esocial-contexto__value">{{ consultadoEm.data }}</span>
        </div>
      </div>

      <h4><b>Informações no eSocial</b></h4>

      <XmlViewer :xml="formData.strXml" />
    </div>
  </div>
</template>

<script>
import XmlViewer from "vue-xml-viewer";
import { EdForm, EdButton, EdInputSelect, EdInputText } from "template";

export default {
  name: "esocial-lotes-reenviar-email",
  mixins: [],
  components: { XmlViewer, EdForm, EdButton, EdInputSelect, EdInputText },

  props: {
    lstEmpresa: {
      type: [Array],
      default: [],
    },
    loadingEmpresa: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["getEmpresa", "getLayout"],
  watch: {
    lstEmpresa: {
      handler: function (newVal) {},
      deep: true,
    },
    loadingEmpresa() {},
  },

  data() {
    return {
      formData: {
        id_emp: null,
        id_fun: null,
        layout: null,
        busca: null,
        strXml: null,
      },
      loading: false,
      erro: null,
      consultadoEm: {},
    };
  },

  created() {},

  mounted() {},

  methods: {
    consultar() {
      this.loading = true;
      this.erro = null;
      this.formData.strXml = null;

      this.$root.$request
        .post("esocial/lotes/consultar/" + this.formData.id_emp + "/recibo", this.formData)
        .then((result) => {
          this.loading = false;

          if (result.status == 200) {
            this.formData.strXml = result.data;
            this.consultadoEm = {
              busca: this.formData.busca,
              empresa: this.empresaSelecionada(),
              data: this.toDate(new Date()),
            };
          } else {
            this.erro = result.msg || "Não foi possível consultar o recibo no eSocial.";
          }
        });
    },

    empresaSelecionada() {
      var empresa = (this.lstEmpresa || []).find((e) => e.id == this.formData.id_emp);
      return empresa ? empresa.nome : this.formData.id_emp;
    },

    toDate(date) {
      return new Date(date).toLocaleString("pt-BR");
    },
  },
};
</script>

<style lang="scss" scoped>
.consulta-esocial-erro {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: rgba(192, 57, 43, 0.08);
  color: #c0392b;
  font-size: 12px;

  i {
    font-size: 14px;
  }
}

.consulta-esocial-contexto {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 14px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f7f9fb;
  border: 1px solid #eef0f2;
}

.consulta-esocial-contexto__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.consulta-esocial-contexto__label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #9aa0a8;
}

.consulta-esocial-contexto__value {
  font-size: 12px;
  color: #1f2329;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// consulta-recibo.vue?24869f4b